var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllPlatformNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.89188V10.093C3 10.5087 3.25725 10.8811 3.64611 11.0282L11.6461 14.0553C11.8741 14.1416 12.1259 14.1416 12.3539 14.0553L20.3539 11.0282C20.7427 10.8811 21 10.5087 21 10.093V6.89188",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8L11.6461 9.5688C11.8741 9.65508 12.1259 9.65508 12.3539 9.5688L16.5 8",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.35136C3 8.35136 3 7.70467 3 7.09618C3 6.68041 3.25725 6.30808 3.64611 6.16094L11.6461 3.13392C11.8741 3.04763 12.1259 3.04763 12.3539 3.13392L20.3539 6.16094C20.7427 6.30808 21 6.68047 21 7.09623L21 7.86488",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.7027V16.9038C3 17.3195 3.25725 17.6919 3.64611 17.8391L11.6461 20.8661C11.8741 20.9524 12.1259 20.9524 12.3539 20.8661L20.3539 17.8391C20.7427 17.6919 21 17.3195 21 16.9038V13.7027",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.1622C3 15.1622 3 14.4297 3 13.7903C3 13.4348 3.18878 13.106 3.49584 12.9267L5.5 11.7567M21 14.6757L21 13.7904C21 13.4348 20.8112 13.106 20.5042 12.9267L18.5 11.7567",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllPlatformNew);
export default __webpack_public_path__ + "static/media/AllPlatformNew.0d3bc6d5.svg";
export { ForwardRef as ReactComponent };